import Routers from './routers'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/lib/locale/zh_CN';
import { useTranslation } from 'react-i18next';
import enUS from 'antd/lib/locale/en_US';
import { Lang } from './types/lang';
import zhTW from 'antd/lib/locale/zh_TW';
import viVN from 'antd/lib/locale/vi_VN';
import jaJP from 'antd/lib/locale/ja_JP';
import koKR from 'antd/lib/locale/ko_KR';

const antdLocales = {
  'zh-CN': zhCN,
  'en-US': enUS,
  'zh-TW': zhTW,
  'vi-VN': viVN,
  'ja-JP': jaJP,
  'ko-KR': koKR
};

const App = () => {
  const { i18n } = useTranslation();
  const antdLocale = antdLocales[i18n.language as Lang] || enUS;

  return (
    <ConfigProvider theme={{token: {}}} locale={antdLocale}>
      <Routers />
    </ConfigProvider>
  )
}

export default App
